import { connectRefinementList } from 'react-instantsearch-core';

import { TRefinmentListItem } from '../../types';
import { WrappedMultiSelectFilter } from './components/WrappedMultiSelectFilter';

function MultiSelectFilter(props: TRefinmentListItem) {
  const { attribute } = props;
  const Component = connectRefinementList((refinmentListProps) =>
    WrappedMultiSelectFilter({ ...props, ...refinmentListProps })
  );
  return <Component attribute={attribute} />;
}

export default MultiSelectFilter;
